import { render, staticRenderFns } from "./School.vue?vue&type=template&id=256ffe16&scoped=true&"
var script = {}
import style0 from "./School.vue?vue&type=style&index=0&id=256ffe16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ffe16",
  null
  
)

export default component.exports